import React, { Component } from 'react'
import CleanersDashboardHeader from '../../CleanersDashboardComponents/Shared/DashboardCleanersHeader/DashboardCleanersHeader'
import * as DashboardError500Constant from './ErrorsConstant'
import ReusableButton from '../../SharedComponents/Button/Button'
import '../../CSS/dashboard.css'

class CleanersDashboardError500 extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<CleanersDashboardHeader/>
					<ReusableButton className="ErrorButton" buttonText="View report" disabled={true}></ReusableButton>
                    <div className="ErrorDashboard">
                    <p>{DashboardError500Constant.Error500DashboardParagraph}</p>
				</div>
			</div>
		)
	}
}

export default CleanersDashboardError500;